import {withRouter} from "react-router-dom";
import * as React from "react";
import {Fragment} from "react";
import UtilityLimitIncreaseTypeService from "../../../services/Util/UtilityLimitIncreaseTypeService";
import {Button, Card, CardBody, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import DropdownComponent from "../../../components/DropdownComponent";
import SFXLoadingComponent from "../../../components/SFXLoadingComponent";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import S3DocumentUploadComponent from "../../../components/S3DocumentUploadComponent";
import FileUtil from "../../../domain/Util/FileUtil";
import LimitIncreaseDocumentService from "../../../services/Limit/LimitIncreaseDocumentService";
import ToastHelper from "../../../utils/ToastHelper";
import RegistrationLimitIncreaseService from "../../../services/Registration/RegistrationLimitIncreaseService";
import {stringValidator} from "../../../domain/RequiredFieldTypes";
import LimitIncreaseCardView from "./LimitIncreaseCardView";

const SOURCE_OF_INCOME = "sourceOfIncome";
const PROOF_OF_INCOME = "proofOfIncome";
const PROOF_OF_ADDRESS = "proofOfAddress";
const LIMIT_INCREASE_PENDING = "limitIncreasePending";

const DOCUMENT_MIN_MAX_CONFIG = {
    "proofOfIncome": {
        "min": 1,
        "max": 9
    },
    "proofOfAddress": {
        "min": 0,
        "max": 9
    },
};

class LimitIncrease extends React.Component {

    constructor(props) {
        super(props);

        this.registrationId = this.props.customer.registrationId;

        this.state = {
            nextProofOfIncomeId: DOCUMENT_MIN_MAX_CONFIG[PROOF_OF_INCOME]["min"],
            nextProofOfAddressId: DOCUMENT_MIN_MAX_CONFIG[PROOF_OF_ADDRESS]["min"],
            selectedOptions: {
                sourceOfIncome: [],
                proofOfIncome: {},
                proofOfAddress: {}
            },
            selectedDocuments: {
                proofOfIncome: {},
                proofOfAddress: {}
            },
            sourceOfIncomeOptions: [],
            proofOfIncomeOptions: [],
            proofOfAddressOptions: [],

            uploadedDocuments: {
                proofOfIncome: {},
                proofOfAddress: {}
            },

            currentTab: SOURCE_OF_INCOME,
            loading: true,

            inValidFields: {},
            validFields: {},

            documentUploading: false,

            showErrorModal: false,
            errors: []
        };

        this.schema = {
            sourceOfIncome: stringValidator("sourceOfIncome", "Source Of Income", true)
        };
    }

    componentDidMount() {

        this.props.setHeader("Increase Limit");

        let promiseArr = [];
        promiseArr.push(UtilityLimitIncreaseTypeService.retrieveSourceOfIncomeTypes());
        promiseArr.push(UtilityLimitIncreaseTypeService.retrieveProofOfIncomeTypes());
        promiseArr.push(UtilityLimitIncreaseTypeService.retrieveProofOfAddressTypes());

        Promise.all(promiseArr).then(responseArr => {
            let sourceOfIncome = responseArr[0];
            let proofOfIncome = responseArr[1];
            let proofOfAddress = responseArr[2];

            this.setState({
                sourceOfIncomeOptions: sourceOfIncome,
                proofOfIncomeOptions: proofOfIncome,
                proofOfAddressOptions: proofOfAddress,
                loading: false
            })
        });

        this.createDefaultDocumentRequirements();
    }

    validateInputFields(field) {

        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state.selectedOptions[field].displayValue === undefined ? this.state.selectedOptions[field] : this.state.selectedOptions[field].displayValue;

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];

                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        })
    }

    createDefaultDocumentRequirements() {

        let previousOptions = {...this.state.selectedOptions};
        let previousDocuments = {...this.state.selectedDocuments};

        for (let i = 0; i < DOCUMENT_MIN_MAX_CONFIG[PROOF_OF_INCOME]["min"]; i++) {
            previousOptions[PROOF_OF_INCOME][i] = {};
            previousDocuments[PROOF_OF_INCOME][i] = {};
        }
        for (let j = 0; j < DOCUMENT_MIN_MAX_CONFIG[PROOF_OF_ADDRESS]["min"]; j++) {
            previousOptions[PROOF_OF_ADDRESS][j] = {};
            previousDocuments[PROOF_OF_ADDRESS][j] = {};
        }

        this.setState({
            selectedOptions: previousOptions,
            selectedDocuments: previousDocuments
        })
    }

    dropdownSourceOfIncomeChange(selectedOption, field) {

        let previousSelected = {...this.state.selectedOptions};

        previousSelected[field] = selectedOption;

        this.setState({
            selectedOptions: previousSelected
        }, () => this.validateInputFields(field))
    }

    dropdownChange(selectedOption, field, id) {

        let previousSelected = {...this.state.selectedOptions};

        previousSelected[field][id] = selectedOption;

        this.setState({
            selectedOptions: previousSelected
        })
    }

    addNewProofOfIncomeDocument() {

        let previousProofOfIncomeOptions = {...this.state.selectedOptions};
        let previousProofOfIncomeDocuments = {...this.state.selectedDocuments};
        let previousId = this.state.nextProofOfIncomeId;

        previousProofOfIncomeOptions[PROOF_OF_INCOME][previousId] = {};
        previousProofOfIncomeDocuments[PROOF_OF_INCOME][previousId] = {};

        previousId++;

        this.setState({
            selectedOptions: previousProofOfIncomeOptions,
            selectedDocuments: previousProofOfIncomeDocuments,
            nextProofOfIncomeId: previousId
        })
    }

    addNewProofOfAddressDocument() {

        let previousProofOfAddressOptions = {...this.state.selectedOptions};
        let previousProofOfAddressDocuments = {...this.state.selectedDocuments};
        let previousId = this.state.nextProofOfAddressId;

        previousProofOfAddressOptions[PROOF_OF_ADDRESS][previousId] = {};
        previousProofOfAddressDocuments[PROOF_OF_ADDRESS][previousId] = {};

        previousId++;

        this.setState({
            selectedOptions: previousProofOfAddressOptions,
            selectedDocuments: previousProofOfAddressDocuments,
            nextProofOfAddressId: previousId
        })
    }

    removeDocuments(id, field) {

        let previousProofOfIncomeOptions = {...this.state.selectedOptions};
        delete previousProofOfIncomeOptions[field][id];

        let previousProofOfIncomeDocuments = {...this.state.selectedDocuments};
        delete previousProofOfIncomeDocuments[field][id];

        let previousUploadedDocuments = {...this.state.uploadedDocuments};
        delete previousUploadedDocuments[field][id];

        this.setState({
            selectedOptions: previousProofOfIncomeOptions,
            selectedDocuments: previousProofOfIncomeDocuments,
            uploadedDocuments: previousUploadedDocuments
        })
    }

    isAddMoreActive(field) {

        let documentCount = Object.keys(this.state.selectedOptions[field]).length;

        let addMoreDocuments = true;
        if (documentCount > DOCUMENT_MIN_MAX_CONFIG[field]["max"] - 1) {
            addMoreDocuments = false;
        }

        return addMoreDocuments;
    }

    handleUpload(field, id) {

        let self = this;

        let file = this.state.selectedDocuments[field][id];

        let fileType = FileUtil.getExtensionOfFile(file.fileUpload.name);
        let mimeType = FileUtil.getMimeType(fileType);

        let s3Document = {
            "file-type": fileType,
            "document-type": field === "proofOfIncome" ? "PROOF_OF_INCOME" : "PROOF_OF_ADDRESS"
        };

        LimitIncreaseDocumentService.retrievePresignedUrl(s3Document).then(response => {
            if (response.presignedUrl === undefined) {
                ToastHelper.error("Failed to retrieve upload url.");
                return;
            }

            const xhr = new XMLHttpRequest();
            xhr.open('PUT', response.presignedUrl);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        let uploadedDocument = {...self.state.uploadedDocuments};
                        uploadedDocument[field][id] = response;
                        self.setState({
                            uploadedDocuments: uploadedDocument,
                            documentUploading: false
                        });
                    } else {
                        ToastHelper.error("Error while uploading image.");
                    }
                }
            };
            xhr.overrideMimeType(mimeType);
            xhr.setRequestHeader('Content-Type', mimeType);
            xhr.send(file.fileUpload);
        });
    }

    generateLimitIncreaseRequest() {

        let limitIncreaseRequest = {};
        limitIncreaseRequest["registration-id"] = this.registrationId;
        limitIncreaseRequest["address-documents"] = [];

        Object.keys(this.state.uploadedDocuments[PROOF_OF_ADDRESS]).forEach(singleDocument => {
            let newProofOfAddress = {};
            newProofOfAddress["meta-data-id"] = this.state.uploadedDocuments[PROOF_OF_ADDRESS][singleDocument].id;
            newProofOfAddress["document-type"] = this.state.selectedOptions[PROOF_OF_ADDRESS][singleDocument].name;
            limitIncreaseRequest["address-documents"].push(newProofOfAddress);
        });

        limitIncreaseRequest["sources-of-income"] = [];

        let sourceOfIncome = {};
        sourceOfIncome["source"] = this.state.selectedOptions["sourceOfIncome"].name;
        sourceOfIncome["value"] = "0";
        sourceOfIncome["income-documents"] = [];

        Object.keys(this.state.uploadedDocuments[PROOF_OF_INCOME]).forEach(singleDocument => {
            let newProofOfAddress = {};
            newProofOfAddress["meta-data-id"] = this.state.uploadedDocuments[PROOF_OF_INCOME][singleDocument].id;
            newProofOfAddress["document-type"] = this.state.selectedOptions[PROOF_OF_INCOME][singleDocument].name;
            sourceOfIncome["income-documents"].push(newProofOfAddress);
        });

        limitIncreaseRequest["sources-of-income"].push(sourceOfIncome);

        RegistrationLimitIncreaseService.requestLimitIncrease(limitIncreaseRequest).then(response => {
            if (response["error-code"]) {
                this.setState({
                    showErrorModal: true,
                    errors: response
                })
            } else {
                this.setState({
                    currentTab: LIMIT_INCREASE_PENDING
                })
            }
        });
    }

    hasBeenTouched(field) {

        let previousTouched = {...this.state.touchedFields};
        previousTouched[field] = true;
        this.setState({
                touchedFields: previousTouched
            }, () => this.validateInputFields(field)
        )
    }

    isSourceOfIncomeValid() {

        return (this.state.validFields["sourceOfIncome"]);
    }

    areDocumentsValid(field) {

        let areDocumentsValid = true;

        Object.keys(this.state.selectedOptions[field]).forEach(key => {
            areDocumentsValid = this.state.selectedOptions[field][key].name !== undefined && this.state.selectedDocuments[field][key].fileName !== undefined && !this.state.documentUploading;
        });

        return areDocumentsValid;

    }

    render() {

        if (this.state.loading)
            return <SFXLoadingComponent/>;

        return <Fragment>

            {this.props.isMobile ? this.renderContent("mobile") : <LimitIncreaseCardView
                component={this.renderContent("browser")}
            />}

        </Fragment>

    }

    renderContent(className) {

        return <Fragment>

            {this.props.isMobile ? <div style={{height: "95%", overflowX: "hidden"}}>
                    {this.state.showErrorModal && this.renderErrorModal(className)}
                    {this.state.currentTab === SOURCE_OF_INCOME && this.renderSourceOfIncome(className)}
                    {this.state.currentTab === PROOF_OF_INCOME && this.renderProofOfIncome(className)}
                    {this.state.currentTab === PROOF_OF_ADDRESS && this.renderProofOfAddress(className)}
                    {this.state.currentTab === LIMIT_INCREASE_PENDING && this.renderLimitIncreasePending(className)}
                </div>
                :
                <div style={{height: "95%", width: "75%", overflowX: "hidden", margin: "auto"}}>
                    {this.state.showErrorModal && this.renderErrorModal(className)}
                    {this.state.currentTab === SOURCE_OF_INCOME && this.renderSourceOfIncome(className)}
                    {this.state.currentTab === PROOF_OF_INCOME && this.renderProofOfIncome(className)}
                    {this.state.currentTab === PROOF_OF_ADDRESS && this.renderProofOfAddress(className)}
                    {this.state.currentTab === LIMIT_INCREASE_PENDING && this.renderLimitIncreasePending(className)}
                </div>
            }

        </Fragment>

    }

    renderSourceOfIncome(className) {

        return <Fragment>

            {this.renderHeaderBanner("Source of Income")}

            {this.renderSourceOfIncomeDropdown(className, this.state.sourceOfIncomeOptions, "sourceOfIncome", "Select Source of Income Type")}

            {this.renderSourceOfIncomeButton(className)}

        </Fragment>

    }

    renderProofOfIncome(className) {

        return <Fragment>

            {this.renderHeaderBanner("Proof of Income", PROOF_OF_INCOME, true)}

            {this.renderImageTypeSelectorAndUploader(className, this.state.proofOfIncomeOptions, PROOF_OF_INCOME, "Select Proof of Income Type", "Proof of Income")}

            {this.renderProofOfIncomeButton(className)}
            {this.renderBackButton(className, SOURCE_OF_INCOME)}

        </Fragment>

    }

    renderProofOfAddress(className) {

        return <Fragment>

            {this.renderHeaderBanner("Proof of Address", PROOF_OF_ADDRESS, true)}

            {this.renderImageTypeSelectorAndUploader(className, this.state.proofOfAddressOptions, PROOF_OF_ADDRESS, "Select Proof of Address", "Proof of Address")}

            {this.renderIncreaseLimitButton(className)}
            {this.renderBackButton(className, PROOF_OF_INCOME)}

        </Fragment>

    }

    renderLimitIncreasePending(className) {

        return <div style={{color: "grey", fontSize: "24px", fontWeight: "bold", textAlign: "center"}}>
            Your limit increase is pending verification.
        </div>
    }

    renderImageTypeSelectorAndUploader(className, dropdownOptions, field, text, optionalText) {

        if (Object.keys(this.state.selectedOptions[field]).length === 0) {
            return <div style={{textAlign: "center"}}>
                Optional {optionalText} documents.
            </div>
        }

        return <Fragment>

            {Object.keys(this.state.selectedOptions[field]).map(singleKey => {
                return <Card style={{margin: "15px 5px 5px 5px", borderRadius: "10px"}} key={singleKey}>
                    <div>
                        {DOCUMENT_MIN_MAX_CONFIG[field]["min"] === 0
                            ? <div style={{marginLeft: "84%", marginTop: "5px"}}>
                                {this.renderMinusButton(singleKey, field)}
                            </div>
                            : singleKey > DOCUMENT_MIN_MAX_CONFIG[field]["min"] - 1 &&
                            <div style={{marginLeft: "84%", marginTop: "5px"}}>
                                {this.renderMinusButton(singleKey, field)}
                            </div>
                        }
                        {this.renderDropdown(className, dropdownOptions, field, text, singleKey)}
                        {this.renderDocumentDetails(className, field, singleKey)}
                    </div>
                </Card>
            })}

        </Fragment>

    }

    renderDocumentDetails(className, field, id) {

        return <S3DocumentUploadComponent
            documentType={field}
            showButton={false}
            className={className}
            disabled={this.state.selectedOptions[field][id].name === undefined}
            fileSelected={this.state.selectedDocuments[field][id].fileName !== undefined}
            onFileSelected={file => {
                if (file !== null) {
                    let docArr = {...this.state.selectedDocuments};
                    docArr[field][id] = file;
                    this.setState({
                        selectedDocuments: docArr,
                        documentUploading: true
                    }, () => this.handleUpload(field, id));
                }
            }}
        />
    }

    renderSourceOfIncomeDropdown(className, dropdownOptions, field, text) {

        return <Card  style={{margin: "15px 5px 5px 5px", borderRadius: "10px", padding: "30px"}}>
                <DropdownComponent
                    className={className + "_dropdown"}
                    value={this.state.selectedOptions[field] !== undefined ? this.state.selectedOptions[field]["name"] : ""}
                    options={dropdownOptions}
                    optionValue={"name"}
                    optionText={"displayValue"}
                    placeholder={text}
                    onChange={(selectedOption) => {
                        let option = "";
                        if (selectedOption) {
                            option = selectedOption
                        }
                        this.dropdownSourceOfIncomeChange(option, field)
                    }}
                    onBlur={() => this.hasBeenTouched(field)}
                />
                {this.state.inValidFields[field] && this.renderErrorMessage(className, field, this.state.inValidFields[field])}
        </Card>
    }

    renderDropdown(className, dropdownOptions, field, text, id) {

        return <Row className={className + "_row"}>
            <Col>
                <DropdownComponent
                    className={className + "_dropdown"}
                    value={this.state.selectedOptions[field][id] !== undefined ? this.state.selectedOptions[field][id]["name"] : ""}
                    options={dropdownOptions}
                    optionValue={"name"}
                    optionText={"displayValue"}
                    placeholder={text}
                    onChange={(selectedOption) => {
                        let option = "";
                        if (selectedOption) {
                            option = selectedOption
                        }
                        this.dropdownChange(option, field, id)
                    }}
                />
            </Col>
        </Row>
    }

    renderBackButton(className, tab) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_grey_oval_button"}
                onClick={() => {
                    this.setState({
                        currentTab: tab
                    })
                }}
            >Previous
            </SFXButtonComponent>
        </div>
    }

    renderSourceOfIncomeButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_orange_oval_button"}
                onClick={() => {
                    this.setState({
                        currentTab: PROOF_OF_INCOME
                    })
                }}
                disabled={!this.isSourceOfIncomeValid()}
            >Next
            </SFXButtonComponent>
        </div>
    }

    renderProofOfIncomeButton(className) {

        return <div className={className + "_register_button_div"}>
            <Row>
                <Col>
                    <SFXButtonComponent
                        className={className + "_orange_oval_button"}
                        onClick={() => {
                            this.setState({
                                currentTab: PROOF_OF_ADDRESS
                            })
                        }}
                        disabled={!this.areDocumentsValid(PROOF_OF_INCOME)}
                    >Next
                    </SFXButtonComponent>
                </Col>
            </Row>
            {this.state.documentUploading &&
            <Row>
                <Col>
                    {this.renderUploadingDocumentsText()}
                </Col>
            </Row>}
        </div>
    }

    renderIncreaseLimitButton(className) {

        return <div className={className + "_register_button_div"}>
            <Row>
                <Col>
                    <SFXButtonComponent
                        className={className + "_orange_oval_button"}
                        onClick={() => this.generateLimitIncreaseRequest()}
                        disabled={!this.areDocumentsValid(PROOF_OF_ADDRESS)}
                    >
                        Submit Request
                    </SFXButtonComponent>
                </Col>
            </Row>
            {this.state.documentUploading &&
            <Row>
                <Col>
                    {this.renderUploadingDocumentsText()}
                </Col>
            </Row>}
        </div>

    }

    renderUploadingDocumentsText() {

        return <div style={{fontSize: "12px"}}>

            Uploading Documents...

        </div>

    }

    renderHeaderBanner(bannerText, field = "", addButtons = false) {

        return <Fragment>

            <div style={{margin: "5px"}}>
                <Card style={{border: "none", borderBottom: "1px solid grey", borderRadius: "0"}}>
                    <CardBody>
                        <Row>
                            <Col xs={9}>
                                <div style={{fontSize: "16pt", color: "grey", paddingLeft: "12px"}}>
                                    {bannerText}
                                </div>
                            </Col>
                            <Col>
                                {addButtons &&
                                <div style={{paddingLeft: "27px"}}>
                                    <Row>
                                        {this.renderPlusButton(field)}
                                    </Row>
                                </div>
                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>

        </Fragment>
    }

    renderPlusButton(field) {

        let activeStyle = {borderRadius: "50%", backgroundColor: "var(--riaOrange)", border: "none"};
        let inactiveStyle = {borderRadius: "50%", backgroundColor: "grey", border: "none"};

        return <Button
            style={this.isAddMoreActive(field)
                ? activeStyle
                : inactiveStyle
            }
            onClick={() => field === "proofOfIncome"
                ? this.addNewProofOfIncomeDocument()
                : this.addNewProofOfAddressDocument()
            }
            disabled={!this.isAddMoreActive(field)}
        >
            <div className={"fa fa-plus"}/>
        </Button>
    }

    renderMinusButton(id, field) {

        let style = {borderRadius: "50%", backgroundColor: "var(--riaOrange)", border: "none"};

        return <SFXButtonComponent
            style={style}
            onClick={() => this.removeDocuments(id, field)
            }>
            <div className={"fa fa-minus"}/>
        </SFXButtonComponent>
    }

    renderErrorModal(className) {

        return <Modal isOpen={true}>

            <ModalHeader className={className + "_modal_header"}>{this.state.errors["message"]}</ModalHeader>
            <ModalBody>{this.state.errors["errors"]}</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({
                        showErrorModal: false
                    }, () => this.props.history.replace("/home"))}
                >
                    Close
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }

    renderErrorMessage(className, field, message) {
        return <h6 className={className + "_error_text"}>
            {message}
        </h6>;
    }

}

export default withRouter(LimitIncrease);